import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { addPPTAccountData } from '@ppt/state/entities/account/ppt-account.actions';
import { addPPTParcelData } from '@ppt/state/entities/parcel/ppt-parcel.actions';
import { State } from '@state/model';
import { PPTLookupNetworkService, SortInfo, Suggestion } from 'egov-api';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { addPPTBillData } from '../state/entities/bill/ppt-bill.actions';
import { loadPPTState } from '../state/ppt-state/ppt-state.actions';
import { selectPPTDisclaimer, selectPPTStateLoaded } from '../state/ppt-state/ppt-state.selectors';

@Injectable()
export class PPTLookupService
{
    constructor
    (
        // Dependencies

        private readonly networkService: PPTLookupNetworkService,
        private readonly store: Store<State>,
    )
    {
        this.getSuggestions = this.getSuggestions.bind(this);
    }


    // State

    public loadState()
    {
        this.store.dispatch(loadPPTState('PPTLookupService'));
    }

    public readonly stateLoaded$ = this.store.select(selectPPTStateLoaded);


    // Lookup suggestions

    public getSuggestions(query: string): Observable<Suggestion[]>
    {
        return this.networkService.getSuggestions$(query);
    }


    // Actual lookup

    public lookup(query: string, sort?: SortInfo, offset?: number, amount?: number): Observable<string[]>
    {
        return this.networkService.parcelLookup$(query, sort, offset || 0, amount || 20).pipe(
            tap(response =>
            {
                this.store.dispatch(addPPTAccountData('LookupService .lookup()', { accountsData: response.accounts }));
                this.store.dispatch(addPPTParcelData('LookupService .lookup()', { parcelsData: response.parcels }));
                if (response.bills) this.store.dispatch(addPPTBillData('LookupService .lookup()', { billsData: response.bills }));
            }),
            map(response => response.accounts.map(account => account.accountNumber))
        );
    }


    // Disclaimer

    public readonly disclaimer$ = this.store.select(selectPPTDisclaimer);
}
